import styled from "styled-components";

const S = {
    MasterDetailWrapper: styled.div`
        display: grid;
        grid-template-columns: 1.2fr 2fr;
        gap: 40px;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 40px;
        box-sizing: border-box;

        @media (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 0;
        }

        .right-column {
            display: flex;
            align-items: center;
            width: 100%;

            @media (max-width: 1024px) {
                order: -1; /* Mobilde ve tablette video önizlemesi en üstte görünür */
            }

            .detail-card {
                position: relative;
                width: 100%;
                background: #000;
                border-radius: 20px;
                overflow: hidden;
                box-shadow: 0 20px 40px rgba(0,0,0,0.15);
                cursor: pointer;
                transition: transform 0.3s ease, box-shadow 0.3s ease;

                @media (max-width: 768px) {
                    border-radius: 14px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.12);
                }

                &:hover {
                    @media (min-width: 769px) {
                        transform: translateY(-5px) scale(1.02);
                        box-shadow: 0 25px 50px rgba(0, 169, 196, 0.3);
                    }
                }

                .iframe-wrapper {
                    position: relative;
                    width: 100%;
                    padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
                    
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                        transition: opacity 0.3s ease, transform 0.5s ease;
                    }

                    .gradient-overlay {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 75%;
                        background: linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%);
                        pointer-events: none;
                        z-index: 1;
                    }

                    .play-button-overlay {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 76px;
                        height: 76px;
                        background: rgba(0, 169, 196, 0.9);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        box-shadow: 0 4px 15px rgba(0, 169, 196, 0.5);
                        transition: all 0.3s ease;
                        z-index: 2;

                        @media (max-width: 768px) {
                            width: 54px;
                            height: 54px;
                        }

                        svg {
                            width: 38px;
                            height: 38px;
                            margin-left: 4px;

                            @media (max-width: 768px) {
                                width: 28px;
                                height: 28px;
                                margin-left: 2px;
                            }
                        }
                    }

                    .detail-title {
                        position: absolute;
                        bottom: 30px;
                        left: 30px;
                        right: 30px;
                        z-index: 3;

                        @media (max-width: 768px) {
                            bottom: 14px;
                            left: 14px;
                            right: 14px;
                        }

                        h3 {
                            margin: 0;
                            color: #fff;
                            font-size: 1.8em;
                            font-weight: 700;
                            line-height: 1.3;
                            text-shadow: 0 2px 8px rgba(0,0,0,0.6);
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;

                            @media (max-width: 768px) {
                                font-size: 1.1em;
                                line-height: 1.35;
                            }
                        }
                    }
                    
                    &:hover img {
                        @media (min-width: 769px) {
                            opacity: 1;
                            transform: scale(1.05);
                        }
                    }

                    &:hover .play-button-overlay {
                        @media (min-width: 769px) {
                            background: #00A9C4;
                            transform: translate(-50%, -50%) scale(1.1);
                            box-shadow: 0 6px 20px rgba(0, 169, 196, 0.8);
                        }
                    }
                }
            }
        }

        .left-column {
            display: flex;
            flex-direction: column;
            max-height: 600px;
            overflow-y: auto;
            padding-right: 15px;
            width: 100%;
            box-sizing: border-box;

            @media (max-width: 1024px) {
                max-height: 350px;
                padding-right: 0;
            }

            /* Hide scrollbar for an elegant look */
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
            
            &::-webkit-scrollbar {
                display: none; /* Chrome, Safari and Opera */
            }

            .webinar-list {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 12px;

                @media (max-width: 768px) {
                    gap: 8px;
                }

                .list-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 22px;
                    background: #fff;
                    border-radius: 12px;
                    border: 1px solid rgba(0,0,0,0.06);
                    cursor: pointer;
                    transition: all 0.25s ease;
                    box-sizing: border-box;

                    @media (max-width: 768px) {
                        padding: 12px 14px;
                        border-radius: 10px;
                    }

                    .item-title {
                        font-size: 1.05em;
                        font-weight: 600;
                        color: #1a2b34;
                        transition: color 0.25s ease;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        padding-right: 12px;

                        @media (max-width: 768px) {
                            font-size: 0.92em;
                            line-height: 1.35;
                        }
                    }

                    .item-icon {
                        width: 22px;
                        height: 22px;
                        color: rgba(0,0,0,0.25);
                        transition: all 0.25s ease;
                        flex-shrink: 0;

                        @media (max-width: 768px) {
                            width: 18px;
                            height: 18px;
                        }
                    }

                    &:hover, &.active {
                        background: #00A9C4;
                        border-color: #00A9C4;
                        box-shadow: 0 8px 18px rgba(0, 169, 196, 0.25);

                        @media (min-width: 769px) {
                            transform: translateX(8px);
                        }

                        .item-title {
                            color: #fff;
                        }

                        .item-icon {
                            color: #fff;
                            @media (min-width: 769px) {
                                transform: translateX(4px);
                            }
                        }
                    }
                }
            }
        }
    `,
    ModalOverlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.88);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(6px);
        animation: fadeIn 0.25s ease;
        padding: 16px;
        box-sizing: border-box;

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        .modal-content {
            position: relative;
            width: 100%;
            max-width: 960px;
            background: #000;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 0 40px rgba(0, 169, 196, 0.4);
            animation: slideUp 0.35s ease;

            @media (max-width: 768px) {
                border-radius: 12px;
            }

            @keyframes slideUp {
                from { transform: translateY(30px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
            }
        }

        .close-btn {
            position: absolute;
            top: 12px;
            right: 12px;
            background: rgba(0, 0, 0, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.2);
            color: white;
            width: 38px;
            height: 38px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            transition: all 0.25s ease;

            @media (max-width: 768px) {
                width: 32px;
                height: 32px;
                top: 8px;
                right: 8px;
            }

            &:hover {
                background: #00A9C4;
                transform: rotate(90deg);
                border-color: #00A9C4;
            }

            svg {
                width: 22px;
                height: 22px;
                @media (max-width: 768px) {
                    width: 18px;
                    height: 18px;
                }
            }
        }

        .modal-video-wrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
            height: 0;
            
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    `
};

export default S;